import { ReadonlyRepositoryObjectService, Result } from '@softline/core';
import { computed, inject, Injectable } from '@angular/core';
import { LieferantenQuery } from '../types/lieferanten-query';
import { SupplierFibu } from '../types/supplier-fibu';
import { LieferantenFibuRepository } from '../repositories/lieferanten-fibu.repository';
import { SupplierIdService } from './supplier-id.service';

@Injectable()
export class LieferantenFibuService extends ReadonlyRepositoryObjectService<
  SupplierFibu,
  Result<SupplierFibu>,
  LieferantenQuery
> {
  readonly #supplierIdService = inject(SupplierIdService);

  supplierId = computed(() => this.#supplierIdService.supplierId()());
  override params = computed(() => {
    return { id: this.supplierId() };
  });

  constructor() {
    super(inject(LieferantenFibuRepository));
  }

  protected override getValue(
    result: Result<SupplierFibu> | null | undefined
  ): SupplierFibu {
    return result as any;
  }
}
